import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { IconButton, Icon } from '@material-ui/core';

import { ReportsFilter } from '../filters';
import FilterSelector from '../filters/filters-selector';
import MultiLocationFilter from '../filters/multi-location-filter/multi-location-filter.container';

const styles = {
  filterContainer: {
    flexWrap: 'wrap',
    borderRight: 'solid 1px #CCCCCC',
    padding: '15px',
    background: '#ffffff',
    minHeight: 'calc(100vh - 64px)',
    height: '100%',
  },
  filterContainerSmall: {
    flexWrap: 'wrap',
    padding: 0,
    background: '#ffffff',
  },
  refreshButton: {
    float: 'right',
    paddingBottom: '0px',
    width: '50px',
    height: '50px',
    marginTop: '-7px',
    zIndex: 10,
  },
  open: {
    background: '#ffffff',
    height: '50px',
    borderRight: 'solid 1px #000000',
    borderBottom: 'solid 1px #000000',
  },
};

class FilterContainer extends Component {
  render() {
    const {
      isOpen, loadAllReportData, useDesktopLayout, filters,
    } = this.props;

    const filterContainerStyle = useDesktopLayout ? styles.filterContainer : styles.filterContainerSmall;

    const filterComponents = filters.map(filter => (<FilterSelector key={filter} filterName={filter} />));

    return (
      <div
        style={{
          display: isOpen ? 'block' : 'none',
          ...filterContainerStyle,
        }}
      >
        <IconButton onClick={loadAllReportData} style={styles.refreshButton}>
          <Icon>refresh</Icon>
        </IconButton>
        <MultiLocationFilter />
        <ReportsFilter />
        {filterComponents}
      </div>
    );
  }
}

FilterContainer.propTypes = {
  isOpen: PropTypes.bool,
  useDesktopLayout: PropTypes.bool,
  filters: PropTypes.array.isRequired,
  loadAllReportData: PropTypes.func.isRequired,
};

FilterContainer.defaultProps = {
  isOpen: true,
  useDesktopLayout: true,
};

export default FilterContainer;
